window.notificationHandler = function () {
    return {
        notices: [],
        visible: [],
        add(notice) {
            notice.id = Date.now();
            this.notices.push(notice);
            this.fire(notice.id);
        },
        fire(id) {
            let notice = this.notices.find((notice) => notice.id == id);
            this.visible.push(notice);
            const timeShown =
                (notice.duration ?? 2500) + this.visible.length * 1000;
            setTimeout(() => {
                this.remove(id);
            }, timeShown);
        },
        remove(id) {
            const notice = this.visible.find((notice) => notice.id == id);
            const index = this.visible.indexOf(notice);
            this.visible.splice(index, 1);
        },
    };
};

// Manually show notifications used in React environment
window.notify = function (type, title, text, duration = 2500) {
    window.dispatchEvent(
        new CustomEvent("notice", {
            detail: {
                type: type,
                title: title,
                text: text,
                duration: duration,
            },
        })
    );
};
